import { render, staticRenderFns } from "./ivr-setting.vue?vue&type=template&id=530683b8"
import script from "./ivr-setting.vue?vue&type=script&lang=js"
export * from "./ivr-setting.vue?vue&type=script&lang=js"
import style0 from "./ivr-setting.vue?vue&type=style&index=0&id=530683b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports